import * as stylex from '@stylexjs/stylex';
import './form.tokens.stylex';
import { formTokens } from './form.tokens.stylex';
import '../../styles/tokens.stylex';
import { borderRadius, easing, POINTER, shadow, size, spacing, timing, VP } from '../../styles/tokens.stylex';
import './markers.stylex';
import { checkableMarker, inputGroupMarker, inputIconMarker, inputMarker } from './markers.stylex';
export const formStyles = {
  input: {
    kmVPX3: "xsuw8hi x1hxemqb",
    kVAM5u: "xwsnfrh xsmhfx8 x1gi2b5 x1c92qbq",
    kaIpWk: "xakuvmb",
    ksu8eU: "x1y0btm7 xw9s8px",
    kMzoRj: "x1q469ie xdr7fg1",
    k8WAf4: "x1neli0u x13b3nmv",
    kmkexE: "xv9q230",
    kGNEyG: "x6s0dn4",
    kWkggS: "x1o47r4 x1ew4eke",
    kGVxlE: "xw90h5g xxolic8",
    k1xSpc: "x78zum5",
    kjBf7l: "x1uczgqu x1cjxk01 x9gvask xjb47yk",
    k3XXqK: "xaatb59",
    kMeerF: "x1s780dp",
    k8Qsv1: "x1dxsdgl",
    $$css: true
  },
  label: {
    kmVPX3: "x1vuw4d0",
    kVAM5u: "x1qqbrsn xcuit6h x9qb5v",
    kaIpWk: "xckihgu",
    ksu8eU: "x1sxg7mv",
    kMzoRj: "x5blzd3",
    kOIVth: "x1u2rcux",
    k8WAf4: "x1r8ni1o",
    kGNEyG: "x7jrhde",
    kWkggS: "x1evmisj x1tc244p x9bbwt9 x2nqtga",
    kMwMTN: "xx9pm7w",
    kkrTdU: "x1pv7an2",
    k1xSpc: "x1pk0tqh",
    kXwgrk: "xvbno2s xc501uv",
    kLWn49: "x1evy7pa x2hb222",
    kVAEAm: "xhmmst1",
    k9WMMc: "x1pxb3uk",
    kfSwDN: "x87ps6o",
    $$css: true
  },
  inputIconWrapper: {
    kmuXW: "x2lah0s",
    kVAEAm: "x1n2onr6",
    kZKoxP: "x1fju8i8 xsinu92",
    kzqmXN: "x1tjwh29 x16nyxd6",
    $$css: true
  },
  checkableInnerElement: {
    kVQacm: "x7giv3",
    kxichV: "x11x033",
    kGNEyG: "x6s0dn4",
    kSGwAc: "xqcrz7y",
    kOBAk4: "x1y5e3q9",
    k1xSpc: "x78zum5",
    kjj79g: "xl56j7k",
    kayTVb: "x1clqncf",
    kVAEAm: "x1n2onr6",
    kZKoxP: "xxk0z11",
    kzqmXN: "xvy4d1p",
    $$css: true
  },
  checkableAnnotation: {
    kmuXW: "x2lah0s",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  checkableLayout: {
    kGVxlE: "x1gnnqk1",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  inputEditable: {
    k7Eaqz: "xeuugli",
    k8Qsv1: "x1dxsdgl",
    $$css: true
  },
  errorBackground: {
    kSGwAc: "xqcrz7y",
    k1xSpc: "x1rg5ohu",
    $$css: true
  },
  errorMessage: {
    $$css: true
  }
};